module.exports = __webpack_public_path__ + "img/W7001-mod.ef72ab99.jpg";